import QRCode from "react-qr-code";
import './invitacion.css'

export default function Portada({inv}) {
    return (
        <section className="Invitacion_Info">
            {inv.map((data, idx) => (
                <div key={idx}>
                    <p><span className="block-left title-text p2">Con cariño</span></p>
                    <p><span className="block-left title-text p1">{`"${data['NombreC']}"`}</span></p>
                    <p><span className="block-left title-text p1">En este universo de tradición y elegancia, donde cada detalle cuenta una historia de amor eterno, queremos que seas parte de nuestro momento más especial. Tu presencia completará esta celebración única.</span></p>
                    <p><span className="block-left title-text p2">Pase para:</span></p>
                    <p><span className="block-left title-text p2">{`${data['Pases']} Personas`}</span></p>
                    <p><span className="block-left title-text p2">Muestra este QR al asistente</span></p>
                    <p>
                        <QRCode className="Invitacion-QR" value={`https://bodacys.solucioneskmp.com/asistencia/${data['hash']}`} />
                    </p>
                </div>
            ))}
        </section>
    )
}
